define(["models/system/systemFunctions", "models/system/model", "models/portalUser"], function (sysFunc, model, curUser) {

    function Datasource(model, level) {
        this.model = model;
        this.level = level ? level : 4;
        this.skipErrors = true;

        var settings = sysFunc.getUserSettings();
        var cacheStartTime = webix.storage.local.get('cache_start_time');
        this.cacheStartTime = cacheStartTime ? cacheStartTime : 0;
        this.cacheLifetime = settings.cacheLifetime;
        this.cacheToggles = settings.cacheToggles;
        this.cacheDictionaries = settings.cacheDictionaries;
    }

    /**
     * Получаем список постоянных значений по определенному параметру
     * @param toggle_name
     * @param onSuccess
     * @param onError
     * @param filters
     */
    Datasource.prototype.getToggle = function (toggle_name, onSuccess, onError, filters) {
        if (this.cacheToggles && !filters) {
            var currentTime = +new Date();
            if (currentTime > this.cacheStartTime + this.cacheLifetime) {
                this.cacheStartTime = currentTime;
                webix.storage.local.put('cache_start_time', currentTime);
                webix.storage.local.put('cachedData', { toggle: {}, dictionary: {} });
            } else {
                var collection = this.getCachedCollection('toggle', toggle_name);
                var response = {
                    status: 'success',
                    data: collection
                };
                if (collection) {
                    onSuccess(response, collection);
                    return;
                }
            }
        }

        var This = this;
        var custFilter = sysFunc.convertFiltersToQuery(filters);

        if (!toggle_name) throw APPLOCALE.messages.msgMissToggle;

        webix.ajax().sync().get(API_URL + "getToggle?toggle_name=" + toggle_name + custFilter, {
            success: function success(text, data, XmlHttpRequest) {

                var response;
                try {
                    response = JSON.parse(text);
                } catch (e) {
                    if (onError) onError(e.message, "100");
                    return;
                }

                if (onSuccess) {
                    var toggleArr = [],
                        curData = response.data;

                    for (var key in curData) {
                        var toggleItem = {};
                        toggleItem.id = curData[key].toggle_code;
                        toggleItem.value = curData[key].toggle_label;
                        toggleArr.push(toggleItem);
                    }
                    if (This.cacheToggles && !filters) {
                        This.cacheCollection('toggle', toggle_name, toggleArr);
                    }
                    onSuccess(response, toggleArr);
                }
            },

            error: function error(text, data, XmlHttpRequest) {
                This.actionOnErrorAjax(text, data, XmlHttpRequest, onError);
            }
        });
    };

    /**
     * Получаем список значений из выбранной таблицы
     * @param dictionary_name
     * @param onSuccess
     * @param onError
     * @param filters
     */
    Datasource.prototype.loadColumnDictionary = function (dictionary_name, onSuccess, onError, filters, noToggle) {
        var prefix = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "get";


        if (this.cacheDictionaries && !filters) {
            var currentTime = +new Date();
            if (currentTime > this.cacheStartTime + this.cacheLifetime) {
                this.cacheStartTime = currentTime;
                webix.storage.local.put('cache_start_time', currentTime);
                webix.storage.local.put('cachedData', { toggle: {}, dictionary: {} });
            } else {
                var collection = this.getCachedCollection('dictionary', dictionary_name);
                if (collection) {
                    var response = {
                        status: 'success',
                        data: collection
                    };
                    onSuccess(collection);
                    return;
                }
            }
        }

        if (!dictionary_name) throw APPLOCALE.messages.msgMissDictionary;
        var This = this,
            custFilter = sysFunc.convertFiltersToQuery(filters, noToggle);

        var url = API_URL + prefix + dictionary_name + "?toggle=true" + custFilter;

        if (noToggle) url = API_URL + prefix + dictionary_name + custFilter;

        webix.ajax(url, {
            success: function success(text, data, XmlHttpRequest) {

                var response;
                try {
                    response = JSON.parse(text);
                } catch (e) {
                    if (onError) onError(e.message, "100");
                    return;
                }

                if (This.cacheDictionaries) {
                    This.cacheCollection('dictionary', dictionary_name, response.data);
                }
                if (onSuccess) onSuccess(response);
            },

            error: function error(text, data, XmlHttpRequest) {
                This.actionOnErrorAjax(text, data, XmlHttpRequest, onError);
            }
        });
    };

    /**
     * Получаем запись по id
     * @param filters
     * @param onSuccess
     * @param onError
     */
    Datasource.prototype.getRecord = function (filters, onSuccess, onError, endPoint) {
        var prefix = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "get";

        var This = this;

        var urlEndPoint;
        if (endPoint) {
            urlEndPoint = endPoint;
        } else urlEndPoint = this.model.url;

        if (!filters) {
            throw APPLOCALE.messages.msgMissRecordID;
        }

        var custFilter = sysFunc.convertFiltersToQuery(filters, true);

        webix.ajax().get(API_URL + prefix + urlEndPoint + custFilter, {
            success: function success(text, data, XmlHttpRequest) {
                //webix.message({type: "success", text: APPLOCALE.messages.msgDataSelected});

                var response;
                try {
                    response = JSON.parse(text);
                } catch (e) {
                    if (onError) onError(e.message, "100");
                    return;
                }

                if (onSuccess) onSuccess(response, response.data);
            },

            error: function error(text, data, XmlHttpRequest) {

                This.actionOnErrorAjax(text, data, XmlHttpRequest, onError);
            }
        });
    };

    /**
     * Получаем запись по кастомному фильтру, который задает пользователь в массиве, либо все записи, если фильтр не задан
     * @param filters
     * @param onSuccess
     * @param onError
     */
    Datasource.prototype.getRecords = function (filters, onSuccess, onError, custom, endPoint) {
        var prefix = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "get";

        var This = this;

        var custFilter = "";
        if (!custom) {
            custFilter = sysFunc.convertFiltersToQuery(filters, true);
        }
        var urlEndPoint;
        if (endPoint) {
            urlEndPoint = endPoint;
        } else urlEndPoint = this.model.url;

        if (custom) {
            custFilter = "/" + filters;
        }

        webix.ajax().get(API_URL + prefix + urlEndPoint + custFilter, {
            success: function success(text, data, XmlHttpRequest) {

                var response;
                try {
                    response = JSON.parse(text);
                } catch (e) {
                    if (onError) onError(e.message, "100");
                    return;
                }
                if (onSuccess) {
                    onSuccess(response, response.data);
                }
            },

            error: function error(text, data, XmlHttpRequest) {
                This.actionOnErrorAjax(text, data, XmlHttpRequest, onError);
            }
        });
    };

    /**
     * Формируем URL по фильтру
     * @param filters
     * @param endPoint
     * @param custom
     * @returns {*}
     */
    Datasource.prototype.getDataCollectionDefinition = function (filters, endPoint, custom) {
        var prefix = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "get";


        var urlEndPoint;
        if (endPoint) {
            urlEndPoint = endPoint;
        } else urlEndPoint = this.model.url;

        var custFilter = "";
        if (!custom) {
            custFilter = sysFunc.convertFiltersToQuery(filters, true);
        }

        var fltUrl = API_URL + prefix + urlEndPoint + custFilter;

        if (custom) {
            fltUrl = API_URL + prefix + urlEndPoint + filters;
        }

        return fltUrl;
    };

    /**
     * Обновляем одну запись, передавая атрибуты записи
     * @param updRecord
     * @param onSuccess
     * @param onError
     * @param customUrl
     */
    Datasource.prototype.updateRecord = function (updRecord, onSuccess, onError, customUrl, silent) {
        var This = this;

        if (!updRecord) {
            throw APPLOCALE.messages.msgMissUpdData;
        }

        var endPoint;
        if (customUrl) endPoint = customUrl;else endPoint = this.model.url;

        webix.ajax().headers({
            "Content-type": "application/json"
        }).post(API_URL + "change" + endPoint, {
            "webix_operation": "update",
            "data": updRecord
        }, {
            success: function success(text, data, XmlHttpRequest) {
                if (!silent) webix.message({ type: "success", text: APPLOCALE.messages.msgDataChng });

                var response;
                try {
                    response = JSON.parse(text);
                } catch (e) {
                    if (onError) onError(e.message, "100");
                    return;
                }

                if (onSuccess) onSuccess(response, updRecord);
            },
            error: function error(text, data, XmlHttpRequest) {
                This.actionOnErrorAjax(text, data, XmlHttpRequest, onError);
            }
        });
    };

    /**
     * Обновляем массив записей, передавая их обновленные атрибуты
     * @param updRecords
     * @param onSuccess
     * @param onError
     * @param customUrl
     */
    Datasource.prototype.updateRecords = function (updRecords, onSuccess, onError, customUrl, layoutId) {
        var This = this;

        if (!updRecords) {
            throw APPLOCALE.messages.msgMissUpdData;
        } else if (!Array.isArray(updRecords)) {
            throw APPLOCALE.messages.msgMissUpdDataArray;
        }

        var endPoint;
        if (customUrl) endPoint = customUrl;else endPoint = this.model.url;

        webix.ajax().headers({
            "Content-type": "application/json"
        }).post(API_URL + "changeMulti" + endPoint, {
            "webix_operation": "update",
            "data": updRecords
        }, {
            success: function success(text, data, XmlHttpRequest) {
                webix.message({ type: "success", text: APPLOCALE.messages.msgDataChng });

                var response;
                try {
                    response = JSON.parse(text);
                } catch (e) {
                    if (onError) onError(e.message, "100");
                    return;
                }

                if (onSuccess) onSuccess(response, updRecords);
            },
            error: function error(text, data, XmlHttpRequest) {
                This.actionOnErrorAjax(text, data, XmlHttpRequest, onError);
            }
        });
    };

    /**
     * Удаление записи, передаем параметры удаляемой записи
     * @param record
     * @param onSuccess
     * @param onError
     * @param customUrl
     */
    Datasource.prototype.deleteRecord = function (record, onSuccess, onError, customUrl) {
        var This = this;

        if (!record) {
            throw APPLOCALE.messages.msgMissRecordID;
        }

        var endPoint;
        if (customUrl) endPoint = customUrl;else endPoint = this.model.url;

        webix.ajax().headers({
            "Content-type": "application/json"
        }).post(API_URL + "change" + endPoint, {
            "webix_operation": "delete",
            "data": record
        }, {
            success: function success(text, data, XmlHttpRequest) {
                //webix.message({type: "success", text: APPLOCALE.messages.msgDataDltd});

                var response;
                try {
                    response = JSON.parse(text);
                } catch (e) {
                    if (onError) onError(e.message, "100", response);
                    return;
                }

                if (onSuccess) onSuccess(response, record);
            },
            error: function error(text, data, XmlHttpRequest) {
                This.actionOnErrorAjax(text, data, XmlHttpRequest, onError);
            }
        });
    };

    /**
     * Удаление массива записей, передаем параметры удаляемых записей
     * @param records
     * @param onSuccess
     * @param onError
     * @param customUrl
     */
    Datasource.prototype.deleteRecords = function (records, onSuccess, onError, customUrl) {
        var This = this;

        if (!records) {
            throw APPLOCALE.messages.msgMissRecordID;
        } else if (!Array.isArray(records)) {
            throw APPLOCALE.messages.msgMissDelDataArray;
        }

        var endPoint;
        if (customUrl) endPoint = customUrl;else endPoint = this.model.url;

        webix.ajax().headers({
            "Content-type": "application/json"
        }).post(API_URL + "changeMulti" + endPoint, {
            "webix_operation": "delete",
            "data": records
        }, {
            success: function success(text, data, XmlHttpRequest) {
                //webix.message({type: "success", text: APPLOCALE.messages.msgDataDltd});

                var response;
                try {
                    response = JSON.parse(text);
                } catch (e) {
                    if (onError) onError(e.message, "100");
                    return;
                }

                if (onSuccess) onSuccess(response, records);
            },
            error: function error(text, data, XmlHttpRequest) {

                This.actionOnErrorAjax(text, data, XmlHttpRequest, onError);
            }
        });
    };

    /**
     * Добавление записи, передаем все атрибуты
     * @param insRecord
     * @param onSuccess
     * @param onError
     * @param customUrl
     */
    Datasource.prototype.insertRecord = function (insRecord, onSuccess, onError, customUrl) {
        var This = this;

        if (!insRecord) {
            throw APPLOCALE.messages.msgMissUpdData;
        }

        var endPoint;
        if (customUrl) endPoint = customUrl;else endPoint = this.model.url;

        webix.ajax().headers({
            "Content-type": "application/json"
        }).post(API_URL + "change" + endPoint, {
            "webix_operation": "insert",
            "data": insRecord
        }, {
            success: function success(text, data, XmlHttpRequest) {
                //webix.message({type: "success", text: APPLOCALE.messages.msgDataInst});

                var response;
                try {
                    response = JSON.parse(text);
                } catch (e) {
                    if (onError) onError(e.message, "100");
                    return;
                }

                if (onSuccess) onSuccess(response, insRecord);
            },
            error: function error(text, data, XmlHttpRequest) {
                This.actionOnErrorAjax(text, data, XmlHttpRequest, onError);
            }
        });
    };

    /**
     * Добавление массива записей, передаем все атрибуты
     * @param insRecords
     * @param onSuccess
     * @param onError
     * @param customUrl
     */
    Datasource.prototype.insertRecords = function (insRecords, onSuccess, onError, customUrl) {
        var This = this;

        if (!insRecords) {
            throw APPLOCALE.messages.msgMissUpdData;
        } else if (!Array.isArray(insRecords)) {
            throw APPLOCALE.messages.msgMissInsDataArray;
        }

        var endPoint;
        if (customUrl) endPoint = customUrl;else endPoint = this.model.url;

        webix.ajax().headers({
            "Content-type": "application/json"
        }).post(API_URL + "changeMulti" + endPoint, {
            "webix_operation": "insert",
            "data": insRecords
        }, {
            success: function success(text, data, XmlHttpRequest) {
                //webix.message({type: "success", text: APPLOCALE.messages.msgDataInst});

                var response;
                try {
                    response = JSON.parse(text);
                } catch (e) {
                    if (onError) onError(e.message, "100");
                    return;
                }

                if (onSuccess) onSuccess(response, insRecords);
            },
            error: function error(text, data, XmlHttpRequest) {

                This.actionOnErrorAjax(text, data, XmlHttpRequest, onError);
            }
        });
    };

    /**
     * Клонирование записи, передаем все атрибуты
     * @param paramName - название параметра, по которому производится клонирование
     * @param value
     * @param onSuccess
     * @param onError
     * @param customUrl
     */
    Datasource.prototype.cloneRecord = function (paramName, values, onSuccess, onError, customUrl) {
        var This = this;

        if (!values.new_tte_code) {
            throw APPLOCALE.messages.msgMissUpdData;
        }

        var endPoint;
        if (customUrl) endPoint = customUrl;else endPoint = this.model.url;

        var json = {};
        json["old_" + paramName] = values.tte_code;
        json["new_" + paramName] = values.new_tte_code;
        json.project_id = values.project_id === 'all' ? null : values.project_id;

        webix.ajax().headers({
            "Content-type": "application/json"
        }).post(API_URL + "clone" + endPoint, json, {
            success: function success(text, data, XmlHttpRequest) {
                //webix.message({type: "success", text: APPLOCALE.messages.msgDataInst});

                var response;
                try {
                    response = JSON.parse(text);
                } catch (e) {
                    if (onError) onError(e.message, "100");
                    return;
                }

                if (onSuccess) onSuccess(response);
            },
            error: function error(text, data, XmlHttpRequest) {
                This.actionOnErrorAjax(text, data, XmlHttpRequest, onError);
            }
        });
    };

    /**
     * Действия на ошибку Ajax запроса
     * @param text
     * @param data
     * @param XmlHttpRequest
     * @param callback
     */
    Datasource.prototype.actionOnErrorAjax = function (text, data, XmlHttpRequest, callback) {
        // Webix в onLoadError (promise) часто передаёт XHR первым аргументом вместо текста
        const responseText = typeof text === "string"
            ? text
            : ((text && text.responseText) || (XmlHttpRequest && XmlHttpRequest.responseText) || (data && data.responseText) || "");
        const httpStatus = (text && typeof text.status === "number" && text.status)
            || (XmlHttpRequest && XmlHttpRequest.status)
            || (data && data.status)
            || 0;

        try {
            const response = JSON.parse(responseText);
            let errorText;
            if (response.errCode === 403 || httpStatus === 403) {
                const errMsg = response.errMsg || "";
                // Cookies очищены, но portalUser ещё в памяти — Forbidden тоже = истекшая сессия
                const sessionExpired = response.errType === "KPUnauthorizedException"
                    || !curUser.portalUser.userId
                    || /forbidden|unauthorized/i.test(errMsg);
                errorText = errMsg
                    ? APPLOCALE.messages.msgError + errMsg
                    : APPLOCALE.errors.errorLoadDataUnknown;

                if (!sessionExpired) {
                    webix.message({ type: "error", text: errorText });
                    if ($$("mainLayout")) {
                        $$("mainLayout").hideProgress();
                    }

                    const startPage = sysFunc.getStartPageForRole(curUser.portalUser.role);
                    const hash = window.location.hash || "";
                    if (hash.indexOf("#!/app/") === 0) {
                        const currentPage = hash.replace("#!", "");
                        if (currentPage !== startPage && currentPage.indexOf(startPage + "/") !== 0) {
                            window.location.hash = "#!" + startPage;
                        }
                    }

                    if (typeof callback === "function") {
                        callback(response.errMsg, response);
                    }
                    return;
                }

                webix.storage.local.put("redirectUrlAfterAuth", window.location);
                webix.storage.local.put("errorMessageAtLoginPage", errorText);

                const path = window.location.pathname || "/";
                const atEntry = path === "/" || /\/index\.html$/i.test(path);
                if (atEntry) {
                    if (typeof window.__showAuthorize === "function") {
                        window.__showAuthorize();
                    }
                    return;
                }

                window.location.href = "/";
                return;
            }

            if (response.errMsg) {
                if (!webix.isArray(response.data)) {
                    errorText = response.errMsg === "Tariff has zone which exceeds 127"
                        ? APPLOCALE.messages.msgTariffZoneExceeds127
                        : APPLOCALE.messages.msgError + response.errMsg;

                    webix.message({
                        type: "error",
                        text: errorText
                    });
                    $$("mainLayout").hideProgress();
                }
            }
            if (typeof callback === "function") callback(response.errMsg, response);
        } catch (e) {
            if (httpStatus === 401 || httpStatus === 403) {
                webix.storage.local.put("redirectUrlAfterAuth", window.location);
                window.location.href = "/";
                return;
            }
            webix.message({
                type: "error",
                text: APPLOCALE.errors.errorLoadDataUnknown
            });
            $$("mainLayout").hideProgress();
            if (typeof callback === "function") callback(e.message);
        }
    };

    /**
     * Функции работы с кэшем
     *
     * Кэширование коллекции
     * @param type
     * @param collectionName
     * @param collection
     */

    Datasource.prototype.cacheCollection = function (type, collectionName, collection) {
        var cachedData = webix.storage.local.get('cachedData');
        if (!cachedData) cachedData = { toggle: {}, dictionary: {} };
        cachedData[type][collectionName] = collection;
        webix.storage.local.put('cachedData', cachedData);
    };

    /**
     * Получение коллекции из кэша
     * @param type
     * @param collectionName
     * @returns {*}
     */

    Datasource.prototype.getCachedCollection = function (type, collectionName) {
        var cachedData = webix.storage.local.get('cachedData');
        return cachedData ? cachedData[type][collectionName] : null;
    };

    return Datasource;
});
